<template>
    <section>
        <!-- the input field -->
        <div class="input-group">
            <span class="input-group-btn">
                <button @click="newGroup()" type="button" class="btn btn-outline-secondary btn-flat">
                    <i class="fa fa-users"></i>
                    Grupo
                </button>
                <button @click="newData()" type="button" class="btn btn-outline-success btn-flat">
                    <i class="fa fa-user-plus"></i>
                    Novo Signatário
                </button>
            </span>
            <input autofocus type="text" class="form-control" placeholder="Digite o nome ou e-mail para consulta..."
                autocomplete="off" v-model="query" @keydown.down="down" @keydown.up="up" @keydown.enter="hit"
                @keydown.esc="reset" @input="update" />
            <span class="input-group-btn">
                <button @click="listAll()" type="button" class="btn btn-outline-secondary btn-flat">
                    <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                    <template v-else>
                        <i class="fa fa-search" v-show="isEmpty"></i>
                        <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
                    </template>
                </button>
            </span>
        </div>

        <!-- the list -->
        <ul v-show="hasItems">
            <!-- for vue@1.0 use: ($item, item) -->
            <li v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit"
                @mousemove="setActive($item)" :key="item.value">
                <p><span style="margin-left:15px">{{item.nome}}</span></p>
                <p style="margin-left:20px;margin-top:-2%">{{item.email}}</p>
            </li>
            <li class="bg-gray addNew"> &nbsp;&nbsp;<p @click="newData()"><i class="fa fa-plus-circle"></i> Adicionar
                </p>
            </li>
        </ul>
        <ul v-show="!hasItems && query.length >= 2 && showNew">
            <li class="bg-gray addNew"> &nbsp;&nbsp;<p @click="newData()"><i class="fa fa-plus-circle"></i> Adicionar
                </p>
            </li>
        </ul>
    </section>
</template>

<script>
    import VueTypeahead from 'vue-typeahead'

    export default {
        extends: VueTypeahead, // vue@1.0.22+
        // mixins: [VueTypeahead], // vue@1.0.21-
        props: {
            src: String
        },
        data() {
            return {
                showNew: true,
                // The data that would be sent by request
                // (optional)
                data: {},

                // Limit the number of items which is shown at the list
                // (optional)
                limit: 3,

                // The minimum character length needed before triggering
                // (optional)
                minChars: 2,

                // Highlight the first item in the list
                // (optional)
                selectFirst: false,

                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'search'
            }
        },

        methods: {
            // The callback function which is triggered when the user hits on an item
            // (required)
            onHit(item) {
                this.$emit('onSelect', item);
                this.query = item.value;
                this.items = [];
                this.showNew = false;
                // alert(item)
            },
            // The callback function which is triggered when the response data are received
            // (optional)
            prepareResponseData(data) {
                this.showNew = true;
                // data = ...
                return data
            },
            newData() {
                this.$emit('newData');
                this.query = '';
            },
            newGroup() {
                this.$emit('newGroup');
                this.query = '';
            },
            listAll() {
                this.$emit('listAll');
            }
        }
    }
</script>

<style scoped>
    ul {
        list-style-type: none;
    }

    li> :hover {
        cursor: pointer;
    }

    li.active {
        background-color: #2980b9;
        color: white !important;
        cursor: pointer;
    }

    .addNew {
        cursor: pointer;
        margin: auto;
        padding: 2px;
    }
</style>